import { Fragment, useEffect, useMemo } from 'react';
// components
import { Page } from 'theme/elements/Page';
// reducers
import { HeaderPage1 } from 'theme/elements/Headers';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { Box, Link, Stack } from '@mui/material';
import { getActivitiesAsync, getBalancesActivityByCompanyId } from 'services/activity.services';
import ActivitiesTable from 'sections/activity';
import { User } from 'constants/user.constants';
import { getUserDetails } from 'state/reducers/user.reducers';
import { getActivityDates, getNavbarSearchActivityDates, loadingActivities } from 'state/reducers/activity.reducers';
import { Link as RouterLink, useParams } from 'react-router-dom';
import WaitingMessage from 'components/WaitingMessage';
import { getBalancesByCompanyId } from 'services/balance.services';
import { pagesEnum } from 'constants/ui.constants';

export default function ActivityApp() {
  const { reference } = useParams();
  const t = useAppSelector(selectTranslations);
  const dispatch = useAppDispatch();
  const user: User = useAppSelector(getUserDetails);
  const navbarSearchFilterDates = useAppSelector(getNavbarSearchActivityDates);
  const isActivitiesLoading = useAppSelector(loadingActivities);

  const isLoading = useMemo(() => isActivitiesLoading.loadingActivities, [isActivitiesLoading?.loadingActivities]);

  useEffect(() => {
    dispatch(getBalancesByCompanyId());
    dispatch(getBalancesActivityByCompanyId(Number(user?.companyId)));
  }, []);

  useEffect(() => {
    dispatch(
      getActivitiesAsync(user?.companyId, navbarSearchFilterDates.startDate, navbarSearchFilterDates.endDate)
    );
  }, [reference]);
  if (isLoading) {
    return <WaitingMessage />;
  }

  return (
    <Fragment>
      <Page>
        <Stack spacing={{ sm: 5, xs: 2 }}>
          <Stack spacing={1}>
            <HeaderPage1 title={t('page.activity.header.title')} text={t('page.activity.header.text')} />
            <Box>
              <Link
                component={RouterLink}
                to={`/${pagesEnum.REPORT}`}
                underline="always"
                variant="body1"
                sx={{ color: '#195962' }}
              >
                {t('page.activity.reports_link.text')}
              </Link>
            </Box>
          </Stack>
          <ActivitiesTable actionReference={reference} />
        </Stack>
      </Page>
    </Fragment>
  );
}
